export const getters = {
    getUsageProfiles: (state, _getters) => _getters.getUserThemeGroups?.map(({ id }) => id),
    getUsageMeta: (state, _getters) => {
        const usage = true;
        const context = state.context;
        if (context === 'web') {
            const mapName = state.webTheme?.data?.alias;
            return {
                organizationId: _getters.getOrganizationId,
                context,
                usage,
                mapName
            };
        }
        if (context === 'portal') {
            const organizationName = state.portal.organizationName;
            return {
                organizationName,
                context
            };
        }
        const userData = _getters.getUserData;
        const isAdmin = userData?.isAdmin === 1;
        const isFeedbackEditor = userData?.isFeedbackEditor === 1;
        const isSuper = userData?.isSuper === 1;
        const userId = userData?.id;
        const profiles = _getters.getUsageProfiles;
        return {
            organizationId: _getters.getOrganizationId,
            profiles,
            userId,
            context,
            usage,
            isAdmin,
            isFeedbackEditor,
            isSuper
        };
    },
};
